<template>
    <router-view />
</template>
<script setup>
    import autofit from 'autofit.js'
    import {
        onMounted,
        nextTick
    } from 'vue'
    onMounted(() => {
        autofit.init({
            dh: 1080, // 设计稿的高度，默认是 1080
            dw: 1920, // 设计稿的宽度，默认是 1920
            el: "#app", // 渲染的dom，默认是 "body"
            resize: true, // 是否监听resize事件，默认是 true
        }, false)
    })
</script>
<style>
    #app {
        /* background-color: rgba(2, 14, 80, 1); */
        display: flex;
        align-items: center;
        justify-content: center;
        background: url(./assets/images/login/bg.webp) no-repeat;
        background-size: 100% 100%;
    }
</style>